import { createAction, props } from '@ngrx/store';
import { Feature } from 'geojson';
import { ISimulationArea } from '../../../interfaces/simulation/simulation-area/ISimulationArea';


export const toggleGeoSimulator = createAction(
  '[SimulationArea] Toggle GeoSimulator'
)

export const saveSimulationArea = createAction(
  '[SimulationArea] Save Simulation Area',
  props<{ name: string; feature: Feature; areaInKm2: number }>()
);

export const saveSimulationAreaSuccess = createAction(
  '[SimulationArea] Save Simulation Area Success',
  props<{ newArea: ISimulationArea }>()
);

export const saveSimulationAreaFailure = createAction(
  '[SimulationArea] Save Simulation Area Failure',
  props<{ error: any }>()
);

export const loadSimulationAreas = createAction(
  '[SimulationArea] Load Simulation Area' 
)

export const loadSimulationAreasSuccess = createAction(
  '[SimulationArea] Load Simulation Area Success',
  props<{ simulationAreas: Array<ISimulationArea> }>()
)

export const loadSimulationAreasFailure = createAction(
  '[SimulationArea] Load Simulation Area Failure',
  props<{error: any}>()
)